//@flow

import { useGetRoutes } from './routes';

export const useIsSettingsSectionEnabled = (): boolean => {
    const routes = useGetRoutes();
    return routes.some(r => !r.disabled);
};

// [JSX] => [non-JSX] => [JSX]
